import { render, staticRenderFns } from "./ContexteGeopolitique.vue?vue&type=template&id=ffe98066&"
import script from "./ContexteGeopolitique.vue?vue&type=script&lang=js&"
export * from "./ContexteGeopolitique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports